// extracted by mini-css-extract-plugin
export default {"sortingButton":"SortingButton-module__sortingButton___Ir2p5"};